import {
  IComponentOptions,
  IController,
  IFormController,
  IQService
} from 'angular';
import { ILanguage, Language } from '../../../core/entities/language';
import { LanguageService } from '../../../core/services/language/language.service';
import './language-levels-form.component.scss';
import { BehaviorSubject, Subscription } from 'rxjs';
import { combineLatest } from 'rxjs/operators';

class LanguageLevelsFormController implements IController {
  static $inject = ['$q', 'LanguageService'];
  languageLevels: string[];
  languageList: string[];
  languages: Language[];
  maxLanguages = 5;
  roleType: any;
  languageLevelsForm: IFormController;
  formRequired = true;

  $languages: BehaviorSubject<ILanguage[]> = new BehaviorSubject<ILanguage[]>(
    undefined
  );
  $languageList: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(
    undefined
  );

  private $onLanguages: Subscription;

  constructor(
    private $q: IQService,
    private languageService: LanguageService
  ) {}

  $onInit() {
    console.log(this.roleType);
    this.initData();
    this.getAllLanguages();
    console.log(this.languageList);
  }

  $onChanges() {
    this.$languages.next(this.languages);
  }

  $onDestroy() {
    this.$onLanguages.unsubscribe();
  }

  addLanguage() {
    this.languages.push(new Language());
  }

  getAllLanguages() {
    this.$onLanguages = this.$languages
      .pipe(combineLatest(this.$languageList))
      .subscribe((languages) => {
        if (languages[0] && languages[1]) {
          this.languageList = languages[1];
        }
      });
  }

  // onLanguageChange(title, item?) {
  //   if (this.languageList && this.languageList.includes(title)) {
  //     const index = this.languageList.indexOf(title);
  //     if (index >= 0) {
  //       this.languageList.splice(index, 1);
  //     }
  //   }
  // }

  removeLanguage(index: number, language: string) {
    this.languages.splice(index, 1);
    this.languageList = [...this.languageList, language];
  }

  isAddActive(): boolean {
    const lastLanguage = this.languages[this.languages.length - 1];
    if (this.languages.length && lastLanguage.title && lastLanguage.level) {
      return this.languages.length < this.maxLanguages;
    } else if (!this.languages.length) {
      return false;
    }
    return false;
  }

  private initData() {
    this.languageLevels = this.languageService.languageLevels;
    this.$q
      .all([this.languageService.getLanguages()])
      .then(([res]) => {
        this.$languageList.next(res);
      })
      .catch((err) => console.log(err));
  }
}

export const LanguageLevelsFormComponent: IComponentOptions = {
  controller: LanguageLevelsFormController,
  template: require('./language-levels-form.component.html'),
  bindings: {
    languages: '<',
    roleType: '<',
    formRequired: '<'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/language-levels-form/language-levels-form.component.ts